import { Injectable } from '@angular/core';
import { HttpParams, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ServiceClientService } from 'src/app/services/service-client.service';
import { environment } from 'src/environments/environment';
import { AppLink } from 'src/app/models/app-link';
import { Response } from 'src/app/models/user';

@Injectable({
  providedIn: 'root',
})
export class AppLinkService {
  constructor(private serviceClientService: ServiceClientService) {}

  getAll(options: { page: number; limit: number; search?: string }): Observable<Response<AppLink[]>> {
    let params = new HttpParams()
      .set('page', options.page.toString())
      .set('limit', options.limit.toString());

    if (options.search) {
      params = params.set('search', options.search);
    }

    return this.serviceClientService.get<Response<AppLink[]>>(environment.endPoints.getApkLinks, params);
  }

  uploadApk(fileFormData: FormData): Observable<any> {
    return this.serviceClientService.postImage(environment.endPoints.uploadApk, fileFormData);
  }

  uploadApkWithProgress(fileFormData: FormData): Observable<HttpEvent<any>> {
    return this.serviceClientService.postImageWithProgress(environment.endPoints.uploadApk, fileFormData);
  }

  create(payload: { name: string; apkKey: string; appVersion: string; isActive?: boolean }): Observable<Response<AppLink>> {
    return this.serviceClientService.post<typeof payload, Response<AppLink>>(environment.endPoints.createApkLink, payload);
  }

  update(id: string | number, payload: { name: string; apkKey: string; appVersion: string; isActive: boolean; id: string | number }): Observable<Response<AppLink>> {
    const endpoint = `${environment.endPoints.updateApkLink}/${id}`;
    return this.serviceClientService.put<typeof payload, Response<AppLink>>(endpoint, payload);
  }

  delete(id: string | number): Observable<Response<any>> {
    const endpoint = `${environment.endPoints.deleteApkLink}/${id}`;
    return this.serviceClientService.delete<Response<any>>(endpoint);
  }
}


